@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center filter-bar">
                <h5 class="fw-bold mb-0">Gift Certificates</h5>
                <div class="d-flex align-items-center gap-4">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="statusFilter" id="activeOnly"
                            [checked]="statusFilter==='Active'" (change)="onStatusChange('Active')">
                        <label class="form-check-label" for="activeOnly">Active Only</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="statusFilter" id="inactiveOnly"
                            [checked]="statusFilter==='Inactive'" (change)="onStatusChange('Inactive')">
                        <label class="form-check-label" for="inactiveOnly">Inactive Only</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="statusFilter" id="both"
                            [checked]="statusFilter==='Both'" (change)="onStatusChange('Both')">
                        <label class="form-check-label" for="both">Both</label>
                    </div>
                </div>
                <div class="input-group w-25">
                    <input type="text" class="form-control" placeholder="Enter Gift Certificate #"
                        [(ngModel)]="giftCertInput" (keydown.enter)="onGiftCertificateSearch()"
                        (ngModelChange)="onGiftCertificateInputChange($event)">

                    <button class="btn btn-primary" type="button" (click)="onGiftCertificateSearch()">
                        <i class="bi bi-search"></i>
                    </button>
                </div>

            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <ejs-grid [dataSource]="certificates" height="350" (rowSelected)="onRowSelected($event)"
                        (rowSelecting)="onRowSelecting($event)" locale="en-US">
                        <e-columns>
                            <!-- <e-column field="chkSelect" headerText="" width="60" textAlign="Center">
                                <ng-template #template let-data>
                                    <input type="checkbox" class="form-check-input"
                                        [checked]="selectedGiftCertNo === (data.GiftCertificateNo || data.giftCertificateNo)"
                                        (change)="onCheckboxChange(data, $event)" />
                                </ng-template>
                            </e-column> -->
                            <e-column field="GiftCertificateNo" textAlign="left" headerText="Gift Certificate #"
                                width="150"></e-column>
                            <e-column field="StartDate" textAlign="left" headerText="Start Date" width="120"></e-column>
                            <e-column field="ExpiryDate" textAlign="left" headerText="Expiry Date"
                                width="120"></e-column>
                            <e-column field="InitialAmt" headerText="Initial Amount" width="140" textAlign="Right"
                                format="C2" type="number"></e-column>
                            <e-column field="Balance" headerText="Balance" width="100" textAlign="Right"
                                format="C2"></e-column>
                            <e-column field="CustomerName" headerText="Customer Name" textAlign="left"
                                width="150"></e-column>
                            <e-column field="Address" headerText="Address" textAlign="left" width="140"></e-column>
                            <e-column field="GeneratedBy" headerText="Generated By" textAlign="left"
                                width="140"></e-column>
                            <e-column field="view" headerText="View" width="90" textAlign="Center">
                                <ng-template #template let-data>
                                    <a (click)="$event.stopPropagation(); onView(data)"><img
                                            src="./assets/images/view.svg" class="img-fluid" /></a>
                                </ng-template>
                            </e-column>
                            <e-column *ngIf="statusFilter === 'Inactive'" headerText="Renew" width="120"
                                textAlign="Center">
                                <ng-template #template let-data>
                                    <ejs-tooltip id="tooltipRenewGC" target="#renewGCBtn" position="TopLeft"
                                        (beforeOpen)="onBeforeOpen($event)">
                                        <button id="renewGCBtn" class="btn btn-sm btn-success"
                                            (click)="$event.stopPropagation(); onRenew(data)"
                                            [userPermissionHandler]="editPermissionHandlerData">
                                            Renew
                                        </button>
                                    </ejs-tooltip>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div class="row align-items-end my-3">
                <div class="col-md-6"></div>
                <div class="col-md-6 d-flex justify-content-end align-items-end">
                    @if (isAntiquesVillage) {
                    <div class="d-flex align-items-end me-3">
                        <div class="me-2">
                            <label class="form-label mb-1 fw-semibold d-block text-start">
                                From Date
                            </label>
                            <ejs-datepicker [(ngModel)]="fromDate" [max]="toDate" placeholder="Select From Date"
                                format="MM/dd/yyyy" [allowEdit]="false">
                            </ejs-datepicker>
                        </div>
                        <div>
                            <label class="form-label mb-1 fw-semibold d-block text-start">
                                To Date
                            </label>
                            <ejs-datepicker [(ngModel)]="toDate" [min]="fromDate" placeholder="Select To Date"
                                format="MM/dd/yyyy" [allowEdit]="false">
                            </ejs-datepicker>
                        </div>
                    </div>
                    }
                    <button class="btn btnAS me-2" (click)="onReportView()"
                        [disabled]="!certificates || certificates.length === 0">
                        Preview
                    </button>
                    <button class="btn btn-orange" (click)="closeGiftCertificates()">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Renew Gift Certificate Modal -->
<div class="modal fade" id="renewGCModal" tabindex="-1" aria-labelledby="renewGCModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Renew Gift Certificate Expiry Date</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeRenewModal()"></button>
            </div>
            <div class="modal-body">
                <fieldset class="border p-3 mb-3">
                    <legend class="float-none w-auto px-2 fs-6 fw-bold">Gift Certificate Details</legend>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Gift Certificate #</label>
                            <input type="text" class="form-control" [value]="renewGCDetails?.GiftCertificateNo"
                                disabled>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Customer Name</label>
                            <input type="text" class="form-control" [value]="renewGCDetails?.CustomerName" disabled>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Expiry Date</label>
                            <input type="text" class="form-control" [value]="renewGCDetails?.ExpiryDate" disabled>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Balance</label>
                            <input type="text" class="form-control"
                                [value]="renewGCDetails?.Balance | currency:'USD':'symbol':'1.2-2'" disabled>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border p-3 mb-3">
                    <legend class="float-none w-auto px-2 fs-6 fw-bold text-primary">Modified</legend>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">New Expiry Date</label>
                            <ejs-datepicker [(ngModel)]="newExpiryDate" [min]="minExpiryDate" placeholder="MM/dd/yyyy"
                                format="MM/dd/yyyy" (input)="onExpiryDateInput($event)"></ejs-datepicker>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="modal-footer">
                <button class="btn btnAS" (click)="renewGiftCertificate()">Renew Gift Certificate</button>
                <button class="btn btn-orange" data-bs-dismiss="modal" (click)="closeRenewModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="giftCertificateModal" tabindex="-1" aria-labelledby="giftCertificateModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="giftCertificateModalLabel">Track Gift Certificates</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="resetModal()"></button>
            </div>
            <div class="modal-body">
                <div class="mb-2">
                    <label for="giftCertNo" class="form-label fw-semibold">Gift Certificate #</label>
                    <input type="text" class="form-control w-25" id="giftCertNo" [(ngModel)]="giftCertValue" readonly>

                </div>

                <div class="card shadow-sm p-3 mb-3">
                    <div class="row">
                        <div class="col-md-6 mb-2"><strong>Initial Amount:</strong> {{selectedDetails?.initialAmt |
                            currency:'USD':'symbol':'1.2-2'}}</div>
                        <div class="col-md-6 mb-2"><strong>Start Date:</strong> {{selectedDetails?.startDate}}</div>
                        <div class="col-md-6 mb-2"><strong>Balance Amount:</strong> {{selectedDetails?.balance |
                            currency:'USD':'symbol':'1.2-2'}}</div>
                        <div class="col-md-6 mb-2"><strong>Expiry Date:</strong> {{selectedDetails?.expiryDate}}
                        </div>
                        <div class="col-md-6 mb-2"><strong>Generated By:</strong> {{selectedDetails?.generatedBy}}
                        </div>
                        <div class="col-md-6 mb-2">
                            <strong>Customer Name:</strong> {{selectedDetails?.customerName}}<br />
                            <strong class="visibility-hidden">Customer Address:</strong> {{selectedDetails?.address}}
                        </div>
                    </div>
                </div>

                <h6 class="fw-semibold my-2">Invoice Information</h6>
                <ejs-grid [dataSource]="selectedDetails?.invoices || []" height="300" locale="en-US">
                    <e-columns>
                        <e-column field='invoiceNo' headerText='Invoice #' width='120'></e-column>
                        <e-column field='date' headerText='Date' width='150'></e-column>
                        <e-column field='invoiceAmount' headerText='Invoice Amount' width='150' textAlign='Right'
                            format="$#,##0.00;($#,##0.00)"></e-column>
                        <e-column field='gcAmount' headerText='GC Amount' width='150' textAlign='Right'
                            format="$#,##0.00;($#,##0.00)"></e-column>
                        <e-column field='balanceAmount' headerText='Balance Amount' width='180' textAlign='Right'
                            format="$#,##0.00;($#,##0.00)"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-orange" data-bs-dismiss="modal"
                    (click)="resetModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- PDF Preview Modal -->
<div class="modal fade" id="viewReceiptModal" tabindex="-1" aria-labelledby="viewReceiptModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewReceiptModalLabel">Preview</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="500px" frameborder="0"></iframe>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>